const ALL_CAST_INITIAL_STATE = {
	cast: [],
};

export default ALL_CAST_INITIAL_STATE;
